import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  useTheme,
  Stack,
} from "@mui/material";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import getNewTokens from "../../context/RefreshTokens";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { getAssessmentHistoryStyle } from "../../components/customstyles/AssessmentHistory";
import Button from "../../components/customcomponents/CustomButton";
import queryString from "query-string";

const useStyles = () => {
  let theme = useTheme();
  return getAssessmentHistoryStyle(theme);
};
function PrivacyPolicyPage() {
  const styles = useStyles();
  const location = useLocation();
  let url = queryString.parse(location.search);
  const refreshTokens = getNewTokens();
  const history = useHistory();
  const { makeAuthenticatedApiCall } = useContext(AuthContext);
  const [isChecked, setIsChecked] = useState(false);
  const [loadingStarted, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    let apiResult = await makeAuthenticatedApiCall(
      "POST",
      "/api/accepttermsandcondition/updatePrivacyTermsAndCondition"
    );
    if (apiResult.status === 200) {
      await refreshTokens();
      history.push(url?.redirectTo || "/patients");
    }
    setLoading(false);
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      <div
        style={{
          padding: "40px 40px",
          borderRadius: "10px",
          backgroundColor: "white",
          border: "1px solid #0304041A",
          maxWidth: "552px",
        }}
      >
        <Typography variant="h4" fontSize={32} fontWeight={"semibold"} mb={5}>
          Privacy Policy and Terms of Use Notice{" "}
        </Typography>
        <Typography>
          By checking the box below and clicking "Continue," you confirm that
          you have read and agree to our{" "}
          <a
            href="/api/resourceservice/termsOfUse"
            target="_blank"
            style={{ color: "#1E88E5", textDecoration: "none" }}
          >
            Terms of Use
          </a>{" "}
          and{" "}
          <a
            href="/api/resourceservice/privacyPolicy"
            target="_blank"
            style={{ color: "#1E88E5", textDecoration: "none" }}
          >
            Privacy Policy
          </a>
          .
        </Typography>
        <FormGroup sx={{ paddingX: "10px", paddingY: "20px" }}>
          <FormControlLabel
            control={
              <Checkbox
                sx={{
                  "&.Mui-checked": {
                    color: "#2196F3",
                  },
                }}
                onChange={(event) => {
                  let checked = event.target.checked;
                  setIsChecked(checked);
                }}
              />
            }
            label={
              <Typography>
                I agree to the <strong>Privacy Policy</strong> and{" "}
                <strong>Terms of Use.</strong>
              </Typography>
            }
          />
        </FormGroup>
        <Stack spacing={1}>
          <Button
            variant="contained"
            fullWidth={true}
            loading={loadingStarted}
            disabled={!isChecked}
            // type="submit"
            wrapperSx={{ margin: 0 }}
            sx={styles.continueButton}
            onClick={handleSubmit}
          >
            <Typography sx={{ fontSize: "14px" }}>Continue</Typography>
          </Button>
        </Stack>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
